import { Controls, Watcher } from "./components";
import BaseForm from "./Form";

type InternalForm = typeof BaseForm;

interface ExportForm extends InternalForm {
  Controls: typeof Controls;
  Watcher: typeof Watcher;
}

const Form = BaseForm as ExportForm;
Form.Controls = Controls;
Form.Watcher = Watcher;

export default Form;
